import "./propertyRenderers";
import "./appLinks";

export const shopFloorWalkRoutes = [
  {
    path: "/shop-floor-walk",
    name: "sfwDashboardList",
    component: () => import("@shared/shopFloorWalk/views/SFWDashboard.vue"),
  },
  {
    path: "/shop-floor-walk/:dashboardId",
    name: "sfwDashboardDetail",
    props: true,
    component: () =>
      import("@shared/shopFloorWalk/views/SFWDashboardDetail.vue"),
  },
  {
    path: "/sfw-assets",
    name: "sfwAssets",
    component: () => import("@shared/shopFloorWalk/views/SFWAssetListView.vue"),
  },
  {
    path: "/sfw-assets/:template/edit/:id?",
    name: "sfwAssetDetail",
    props: true,
    component: () =>
      import("@shared/shopFloorWalk/views/SFWAssetDetailView.vue"),
  },
  {
    path: "/sfw-walkthrough",
    name: "sfwWalkThrough",
    component: () =>
      import("@shared/shopFloorWalk/views/SFWWalkThroughView.vue"),
  },
  {
    path: "/sfw-walk-history",
    name: "sfwOrderHistory",
    component: () => import("@shared/shopFloorWalk/views/SFWOrderListView.vue"),
  },
  {
    path: "/sfw-walk-history/:template/edit/:id?",
    name: "sfwOrderHistoryDetail",
    props: true,
    component: () => import("@shared/shopFloorWalk/views/SFWOrderDetail.vue"),
  },
];
